/**
 * URL следующей страницы архива акций.
 *
 * Относительные `?page=` склеиваются с базовым AJAX-URL, как в старом popup.
 */
export default function resolveArchivePageUrl(href: string, baseUrl: string): string {
  if (!href) {
    return baseUrl
  }

  if (!/\/.+\//.test(href)) {
    return `${baseUrl}${href}`
  }

  return href
}
